import { render, staticRenderFns } from "./serverOpenDayCount.vue?vue&type=template&id=5af952e2&"
import script from "./serverOpenDayCount.vue?vue&type=script&lang=js&"
export * from "./serverOpenDayCount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/www/game/xcp-vue-xc01/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5af952e2')) {
      api.createRecord('5af952e2', component.options)
    } else {
      api.reload('5af952e2', component.options)
    }
    module.hot.accept("./serverOpenDayCount.vue?vue&type=template&id=5af952e2&", function () {
      api.rerender('5af952e2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/xcpGameData/serverOpenDayCount.vue"
export default component.exports